__turbopack_context__.v({
  "button": "SecondaryCTA-module__aoB0-a__button",
  "buttonSpacer": "SecondaryCTA-module__aoB0-a__buttonSpacer",
  "buttons": "SecondaryCTA-module__aoB0-a__buttons",
  "prompt": "SecondaryCTA-module__aoB0-a__prompt",
  "secondaryCTA": "SecondaryCTA-module__aoB0-a__secondaryCTA",
});
